import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 60, // Increase the width of the switch
  height: 32, // Increase the height of the switch
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 4, // Adjust margin to center thumb better
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(26px)', // Adjust translation for the larger switch
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#A1CE5E',
        opacity: 1,
        border: 0
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5
      }
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#FFFFFF',
      border: '6px solid #fff'
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
      cursor: 'not-allowed'
    }
  },
  '& .MuiSwitch-thumb': {
    color: '#ffffff',
    boxSizing: 'border-box',
    width: 28, // Increase size of the thumb
    height: 28, // Increase size of the thumb
    marginTop: -2
  },
  '& .MuiSwitch-track': {
    borderRadius: 34 / 2, // Adjust border-radius to match the new height
    backgroundColor: theme.palette.mode === 'light' ? '#DBE0E2' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500
    })
  }
}));

export default IOSSwitch;
